module.exports = __webpack_public_path__ + "img/couples-013.d663df64.jpg";